import {POSITIONTARIFFAEND} from './PositionTariffaEndTypes'

export const changePositionTariffaEnd = positionTariffaEnd => {
    return {
        type: POSITIONTARIFFAEND,
        load: positionTariffaEnd
    }
}

export const selectNewPositionTariffaEnd = (positionTariffaEnd) => {

    return (dispatch) => {
        dispatch(changePositionTariffaEnd(positionTariffaEnd))
    }

}